import { AccessRoles } from '../../../../../../../shared/auth';

const getAbilityForReservation = (roles: string[]) => {
  return roles.includes(
    AccessRoles.META_RF_RESERVATION || AccessRoles.FULL_ACCESS
  );
};

export default getAbilityForReservation;
